/**
 * recording.js
 * Quản lý xuất video (MediaRecorder) và thông báo Toast UI.
 */

import { VideoRecorder } from '../studio/video-recorder.js';

export function startVideoRecording(state, switchModeFn) {
  if (!state.videoRecorder) {
    const audioCtx = state.dramaDirector?.audioCtx || state.storyboardDirector?.audioCtx || null;
    state.videoRecorder = new VideoRecorder(state.renderer.domElement, audioCtx);
  }

  const recIndicator = document.getElementById('recording-indicator');
  const recTimeText = document.getElementById('rec-time-text');
  const recStatusText = document.getElementById('rec-status-text');

  if (state.currentMode !== 'drama' && typeof switchModeFn === 'function') {
    switchModeFn('drama');
  }

  if (recIndicator) recIndicator.style.display = 'flex';
  if (recStatusText) recStatusText.textContent = 'Đang ghi hình video:';

  const success = state.videoRecorder.start(30);
  if (!success) {
    if (recIndicator) recIndicator.style.display = 'none';
    alert('Trình duyệt không hỗ trợ MediaRecorder hoặc bị chặn.');
    return;
  }

  if (state.dramaDirector) {
    state.dramaDirector.restart();
  }

  const checkEndInterval = setInterval(() => {
    const activeDir = state.dramaDirector || state.storyboardDirector;
    if (!activeDir) {
      clearInterval(checkEndInterval);
      return;
    }

    const cur = activeDir.currentTime;
    const total = activeDir.duration || activeDir.totalDuration || 62;

    if (recTimeText) recTimeText.textContent = `${cur.toFixed(1)}s / ${total.toFixed(0)}s`;

    if (cur >= total || !activeDir.isPlaying) {
      clearInterval(checkEndInterval);
      setTimeout(() => {
        state.videoRecorder.stop();
        if (recStatusText) recStatusText.textContent = '✅ Đã xuất video:';
        setTimeout(() => {
          if (recIndicator) recIndicator.style.display = 'none';
        }, 3000);
      }, 600);
    }
  }, 250);
}

export function showToastNotification(message, duration = 4000) {
  let toast = document.getElementById('vas-toast-notification');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'vas-toast-notification';
    toast.style.position = 'fixed';
    toast.style.bottom = '24px';
    toast.style.left = '50%';
    toast.style.transform = 'translateX(-50%) translateY(100px)';
    toast.style.background = 'rgba(15, 23, 42, 0.95)';
    toast.style.border = '1px solid #38bdf8';
    toast.style.color = '#f8fafc';
    toast.style.padding = '10px 20px';
    toast.style.borderRadius = '9999px';
    toast.style.fontSize = '13px';
    toast.style.fontWeight = '600';
    toast.style.boxShadow = '0 10px 25px -5px rgba(0, 0, 0, 0.5), 0 0 15px rgba(56, 189, 248, 0.4)';
    toast.style.zIndex = '99999';
    toast.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
    toast.style.opacity = '0';
    toast.style.pointerEvents = 'none';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.style.opacity = '1';
  toast.style.transform = 'translateX(-50%) translateY(0)';
  if (toast._timer) clearTimeout(toast._timer);
  toast._timer = setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(-50%) translateY(100px)';
  }, duration);
}
